// extracted by css-extract-rspack-plugin
export default {"postfix":"MGJbWg"};